import { extend, orderBy } from 'lodash'

import { CRUD, CrudModel } from '../../classes'
import { PatientInsurance, PatientInsuranceStatus } from '../patient-insurance'
import { PatientAccountData } from './patient-account.data'
import { PATIENT_ACCOUNT_CLEARANCE_STATUS } from './patient-account-status'

@CRUD({
  base: '/crud/patient-account',
})
export class PatientAccountModel extends CrudModel {
  eid: string
  patientId: string
  clearanceStatus: PATIENT_ACCOUNT_CLEARANCE_STATUS
  insurances: PatientInsurance[]
  insuranceStatuses: PatientInsuranceStatus[]

  constructor(data: PatientAccountData) {
    super(data, true)

    if (data.insurances) {
      this.insurances = orderBy(data.insurances.map((ins) => new PatientInsurance(ins)), insurance => insurance.typeIndex)
    }
  }

  override toJSON(): any {
    return extend(super.toJSON(), {
      eid: this.eid,
      patientId: this.patientId,
    })
  }
}
